// Stories use saved wording, not briefing actions or generated handbook explanations.
export const uniqueStoryParagraphs = (paragraphs = []) => {
  const seen = new Set();
  return paragraphs.filter((text) => {
    const key = String(text || '').trim().replace(/\s+/g, ' ').replace(/[.!?]+$/, '').toLowerCase();
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

export const getDomainStoryLines = (chapter = {}) => {
  const entries = (chapter.handbook?.groups || []).flatMap((group) => group.entries || []);
  if (entries.length) {
    return uniqueStoryParagraphs(entries.flatMap((entry) => [
      entry.fullText || entry.storyText || entry.headline,
      entry.responseGuidance?.text,
    ]));
  }
  return uniqueStoryParagraphs((chapter.briefing?.items || []).map((item) => item.text));
};
